'use client';
import { IconUser } from '@vs-shop/ui/icons';
import { NavbarUtility } from '@vs-shop/commerce-ui/navbarUtilities';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../../../utils/intl';

import { authModalAtom, AuthModalMode } from '@vs-shop/engine/atom/ui/authModal';
import { useAtomSet } from '@effect/atom-react';

/**
 * The way into an account for a shopper who is not signed in.
 *
 * The same affordance the basket and the comparison are, with the login overlay
 * behind it instead of a route — which is why it takes the neutral `<button>`
 * rather than a link. The overlay's atom stays here.
 */
export default function NavbarCustomerLogin() {
  const intl = getMemoizedIntlShapeWithDefaultLocale();
  const setAuthModal = useAtomSet(authModalAtom);

  const handleLoginClick = () => {
    setAuthModal(() => ({ isOpen: true, mode: AuthModalMode.login }));
  };

  return (
    <NavbarUtility
      onClick={handleLoginClick}
      aria-label={intl.formatMessage({
        id: 'navbar.loginIcon.button.aria',
        defaultMessage: 'Přihlásit se',
      })}
    >
      <IconUser className="h-7 w-7 shrink-0 text-foreground lap:h-8 lap:w-8 [&_path]:stroke-5" />
    </NavbarUtility>
  );
}
